import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';

// Components 

import Box from '@mui/material/Box';
import Button from '../../../general/inputs/Button';
import { updateConsultation } from '../../../../routes/doctor/consultation';
import { setIsConsent, setIsConsentPopupOpened, setIsQrCodePopupOpened } from '../../../../redux/features/doctor/Dashboard/consultation/consultation';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { setNotificationMessage } from '../../../../redux/features/general/notification';
import CancelButton from '../../../general/inputs/CancelButton';
import Popup from '../../../general/popups/items/Popup';


interface Props { 

}; 

const QrCode: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const { consultationId, consultationNoteId } = useParams(); 

    const colors = useAppSelector(state => state.theme.colors); 

    const securityPin = useAppSelector(state => state.consultation.securityPin); 

    const [url, setUrl] = useState(''); 

    // -- 

    const handleQuit = () => { 

        dispatch(setIsQrCodePopupOpened(false)); 

    }; 

    // -- 

    // -- 

    useEffect(() =>  {

        if (consultationNoteId && consultationId) {
            
            setUrl(`https://app.medca.ai/login/mobile/consultation/${consultationId}/note/${consultationNoteId}`); 

        }; 

    },[consultationNoteId, consultationId]); 

    
    // -- 

    return (

        <Popup>

            <QRCodeCanvas value={url} size={window.innerWidth * 0.125} />

            <Box 
                sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center', 
                    marginTop: 4, 
                    width: '80%', 
                    textAlign: 'center', 
                    color: colors?.text
            }}>{t('useConsultationNoteQrCode')}</Box>

            { securityPin && 
            <Box 
                sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center', 
                    marginTop: 2, 
                    width: '80%', 
                    textAlign: 'center', 
                    color: colors?.text
            }}>Security Pin</Box>} 

            { securityPin && 
                <Box
                sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-evenly', 
                    alignItems: 'center', 
                    marginTop: 2, 
                    padding: 2,
                    borderColor: colors?.main,
                    borderRadius: 4, 
                    borderStyle: 'solid',
                    borderWidth: 3,
                    fontWeight: 'bold'
                }}
            >{securityPin}
            </Box>}

            <CancelButton handler={handleQuit} />

        </Popup>

  );

};

export default QrCode;